export default __webpack_public_path__ + "static/media/thumbs-up.2638af7c.svg";